import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormOctagonRotate: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFormOctagonRotate"><Path d="M12.2861 1.55664L19.1807 4.41309L19.4678 4.53125L19.5859 4.81836L22.4424 11.7129L22.5605 12L22.4424 12.2871L19.5859 19.1816L19.4678 19.4688L19.1807 19.5869L12.2861 22.4434L11.999 22.5615L11.7119 22.4434L4.81738 19.5869L4.53027 19.4688L4.41211 19.1816L1.55566 12.2871L1.4375 12L1.55566 11.7129L4.41211 4.81836L4.53027 4.53125L4.81738 4.41309L11.7119 1.55664L11.999 1.43848L12.2861 1.55664Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormOctagonRotate;
